import ENVIRONMENTS from './environments';

const _HOSTS = {
  [ENVIRONMENTS.PRODUCTION]: 'https://homebase.affecttherapeutics.com',
  [ENVIRONMENTS.STAGING]: 'https://homebase.staging.affecttherapeutics.com',
  [ENVIRONMENTS.LOCAL]:
    new URLSearchParams(window.location.search).get('api_host') || 'http://localhost:8000'
};

const _AFFECT_HOSTS = {
  [ENVIRONMENTS.PRODUCTION]: 'https://api.affect.com',
  [ENVIRONMENTS.STAGING]: 'https://api.staging.affect.com',
  [ENVIRONMENTS.LOCAL]:
    new URLSearchParams(window.location.search).get('api_host') || 'http://localhost:8000'
};

function determineHosts(): Record<string, string> {
  const host = window.location.host;

  if (host.includes('affecttherapeutics.com')) {
    return _HOSTS;
  }
  return _AFFECT_HOSTS;
}

const HOSTS = determineHosts();

export default HOSTS;
